module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Da-Hb-Ia.51e2594a.png";